import { create } from 'zustand'

interface IAccountSetupOptions {
    visible?: boolean
    shouldShow?: boolean
}

interface GlobalStore {
    accountSetupPopup: IAccountSetupOptions
}

interface GlobalStoreMethods extends GlobalStore {
    setAccountSetupPopup: (value: IAccountSetupOptions) => void
}

export const useGlobalStore = create<GlobalStoreMethods>()(set => ({
    accountSetupPopup: {
        visible: false,
        shouldShow: false
    },
    setAccountSetupPopup: (value: IAccountSetupOptions) =>
        set(prevState => ({
            ...prevState,
            accountSetupPopup: { ...prevState.accountSetupPopup, ...value }
        }))
}))
